import React, { useState, useEffect, useContext } from "react";
import "./friend.css";
import amis from "../../media/amis.png";
import cancel from "../../media/cancel.svg";
import heart from "../../media/heart.png";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { Context } from "../../Helper/Context";
import userApi from "../../HTTP/user"
import * as helpers from "../../Helper/utils";

const Friend = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [friends, setFriends] = useState([]);
  const [friendRequests, setFriendRequests] = useState([]);
  const [invitations, setInvitations] = useState([]);
  const { friendAction, setFriendAction } = useContext(Context);
  const [publicUsers, setPublicUsers] = useState([]);
  const [userEmail, setUserEmail] = useState("");
  const [resultAddFriend, setResultAddFriend] = useState("");
  const [myGroups, setMyGroups] = useState([]);
  const [otherGroups, setOtherGroups] = useState([]);
  const [groupMembers, setGroupMembers] = useState({});
  const [selectedFriendByGroup, setSelectedFriendByGroup] = useState({});
  const [groupActionMsg, setGroupActionMsg] = useState("");
  const [newGroupName, setNewGroupName] = useState("");

  const currentUserId = JSON.parse(localStorage.getItem('user'))?.id;
  
  // État pour gérer l'affichage actif
  const [activeView, setActiveView] = useState("friends"); // "friends" | "suggestions" | "addFriend" | "groupFriend"
  
  useEffect(() => {
      userApi.getAllFriends().then((f) => setFriends(f))
  }, [friendAction])

  useEffect(() => {
    const refreshGroups = async () => {
      try {
        if (!currentUserId) return
        const groups = await userApi.getFriendGroupsByUser(currentUserId)
        const list = Array.isArray(groups) ? groups : []

        let hasLeaderField = false
        list.forEach((g) => {
          if (g.leader_id !== undefined && g.leader_id !== null) hasLeaderField = true
        })

        if (hasLeaderField) {
          setMyGroups(list.filter((g) => g.leader_id === currentUserId))
          setOtherGroups(list.filter((g) => g.leader_id !== currentUserId))
        } else {
          setMyGroups(list)
          setOtherGroups([])
        }
      } catch (err) {
        console.error("Erreur lors de la récupération des groupes d'amis", err)
      }
    }

    refreshGroups()
  }, [friendAction, currentUserId])

  useEffect(() => {
    // Appel pour obtenir tous les utilisateurs publics
    const fetchPublicUsers = async () => {
        try {
            const users = await userApi.getSuggestedFriends(); 
            setPublicUsers(users);
            console.log(users);
        } catch (error) {
            console.error('Erreur lors de la récupération des utilisateurs publics', error);
        }
    };

    const fetchFriendsRequests = async () => {
      try {
          const requests = await userApi.getFriendRequests();
          setFriendRequests(requests); 
      } catch (error) {
          console.error('Erreur lors de la récupération des demandes d\'ami reçues', error);
      }
    };

    const fetchInvitations = async () => {
      try {
          const invitations = await userApi.getInvitations();
          setInvitations(invitations) 
      } catch (error) {
          console.error('Erreur lors de la récupération des demandes d\'ami envoyées', error);
      }
   };

    fetchPublicUsers()
    fetchInvitations()
    fetchFriendsRequests() 
    // setInterval(() => {
    //   fetchFriendsRequests() 
    // }, 3000); // Rafraîchir
  }, []); // Ce useEffect est déclenché une fois au montage du composant

  const rejectFriend = (friendId) => {
    userApi.removeFriend(friendId)
    setFriendAction(!friendAction)
  }

  const acceptFriend = async (friendId) => {
    try {
      // Appel API pour accepter l'ami
      await userApi.acceptFriendship(friendId);

      // Trouver l'ami dans les demandes d'ami
      const friendIndex = friendRequests.findIndex(friend => friend.id === friendId);
      if (friendIndex > -1) {
        const newFriend = friendRequests[friendIndex];
        console.log('Ajout du nouvel ami '+newFriend)

        // Mettre à jour la liste des demandes d'ami
        const updatedRequests = [...friendRequests];
        updatedRequests.splice(friendIndex, 1);
        setFriendRequests(updatedRequests);

        // Ajouter cet ami à la liste des amis
        setFriends([...friends, newFriend]);
      }

      // Mise à jour pour refléter le changement dans l'interface utilisateur
      setFriendAction(!friendAction);
    } catch (error) {
      console.error('Erreur lors de l\'acceptation de la demande d\'ami', error);
    }
  };
  
  const cancelInvitation = async (friendId) => {
    try {
      // Appel API pour accepter l'ami
      await userApi.removeFriend(friendId);

      // Trouver l'ami dans les demandes d'ami
      const friendIndex = invitations.findIndex(friend => friend.id === friendId);
      if (friendIndex > -1) {
        const newFriend = invitations[friendIndex];
        console.log('Suppression invitation ami '+newFriend)

        // Mettre à jour la liste des demandes d'ami
        const updatedRequests = [...invitations];
        updatedRequests.splice(friendIndex, 1);
        setInvitations(updatedRequests);
      }
    } catch (error) {
      console.error('Erreur lors de l\'acceptation de la demande d\'ami', error);
    }
  };

  const addFriend = async (friendId) => {
    try {
      // Appel API pour accepter l'ami
      await userApi.addFriend(friendId);
  
      // Trouver l'ami dans les demandes d'ami
      const friendIndex = publicUsers.findIndex(friend => friend.id === friendId);
      if (friendIndex > -1) {
        const newFriend = publicUsers[friendIndex];
        console.log('demande de nouvel ami '+newFriend)
  
        // Mettre à jour la liste des demandes d'ami
        const updatedRequests = [...publicUsers];
        updatedRequests.splice(friendIndex, 1);
        setPublicUsers(updatedRequests);
  
        // Ajouter cet ami à la liste des amis
        setInvitations([...invitations, newFriend]);
      }
 
    } catch (error) {
      console.error('Erreur lors de l\'envoi de la demande d\'ami', error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault()
    if (searchTerm.trim() === "") {
      // Si le terme de recherche est vide, réinitialiser les listes
      if (activeView === "friends") {
        userApi.getAllFriends().then((f) => setFriends(f))
        userApi.getInvitations().then((i) => setInvitations(i))
        userApi.getFriendRequests().then((r) => setFriendRequests(r))
      } else {
        userApi.getSuggestedFriends().then((u) => setPublicUsers(u))
      }
    } else {
      console.log("Recherche de :", searchTerm);
      searchUsers(searchTerm);
    }
  }
  
  const searchUsers = async (s) => {
    try { 
      if (activeView === "friends") {
        console.log("Recherche amis et invitations de :", s);
        const results = await userApi.searchFriends(s);
        setFriends(results);
        const invits = await userApi.searchInvitations(s);
        setInvitations(invits);
      } else {
        console.log("Recherche utilisateurs publics de :", s);
        const requests = await userApi.searchUsers(s);
        setPublicUsers(requests);
      }
    } catch (error) {
      console.error('Erreur lors de la recherche', error);
    }
  };

  const addFriendByEmail = async (email) => {
    // 1er appel api pour trouver l'id de l'utlisateur par son email
    // 2eme appel api pour savoir si on est déjà ami ou en attente
    // 3eme appel api pour envoyer la demande d'ami
    try {
      const user = await userApi.getUserIdFromEmail(email);
      if (!user) {
        console.error("Utilisateur non trouvé");
        setResultAddFriend("Utilisateur non trouvé");
        return;
      }

      const isFriend = await userApi.getFriend(user.id);
      console.log("isFriend:", isFriend);
      if (isFriend.length > 0) {
        console.log("Vous êtes déjà amis");
        setResultAddFriend("Vous êtes déjà amis ou en attente");
        return;
      }

      await userApi.addFriend(user.id);
      console.log("Demande d'ami envoyée");
      setResultAddFriend("Demande d'ami envoyée");
    } catch (error) {
      console.error('Erreur lors de l\'ajout d\'un ami par e-mail', error);
      setResultAddFriend("Erreur lors de l'ajout d'un ami");
    }
  };

  const refreshGroupMembers = async (groupId) => {
    try {
      if (!currentUserId || !groupId) return
      const members = await userApi.getFriendsByGroup(currentUserId, groupId)
      setGroupMembers((prev) => ({ ...prev, [groupId]: Array.isArray(members) ? members : [] }))
    } catch (err) {
      console.error("Erreur lors de la récupération des membres du groupe", err)
    }
  }

  const handleCreateGroup = async () => {
    try {
      const created = await userApi.createFriendGroup({ leader_id: currentUserId, name: newGroupName })
      if (created) {
        setGroupActionMsg("Groupe créé")
        setNewGroupName("")
        setFriendAction(!friendAction)
      }
    } catch (err) {
      console.error("Erreur lors de la création du groupe", err)
      setGroupActionMsg("Erreur lors de la création du groupe")
    }
  }

  const handleAddFriendToGroup = async (groupId) => {
    try {
      const friendId = selectedFriendByGroup[groupId]
      if (!friendId) return
      await userApi.addFriendToGroup(currentUserId, groupId, friendId)
      setGroupActionMsg("Ami ajouté au groupe")
      refreshGroupMembers(groupId)
    } catch (err) {
      console.error("Erreur lors de l'ajout au groupe", err)
      setGroupActionMsg("Erreur lors de l'ajout au groupe")
    }
  }

  const handleRemoveFriendFromGroup = async (groupId, friendId) => {
    try {
      await userApi.removeFriendFromGroup(currentUserId, groupId, friendId)
      setGroupActionMsg("Ami retiré du groupe")
      refreshGroupMembers(groupId)
    } catch (err) {
      console.error("Erreur lors de la suppression du groupe", err)
      setGroupActionMsg("Erreur lors de la suppression du groupe")
    }
  }

  const handleDeleteGroup = async (groupId) => {
    try {
      await userApi.deleteFriendGroup(currentUserId, groupId)
      setGroupActionMsg("Groupe supprimé")
      setFriendAction(!friendAction)
      setGroupMembers((prev) => {
        const next = { ...prev }
        delete next[groupId]
        return next
      })
    } catch (err) {
      console.error("Erreur lors de la suppression du groupe", err)
      setGroupActionMsg("Erreur lors de la suppression du groupe")
    }
  }

  const handleLeaveGroup = async (groupId) => {
    try {
      await userApi.leaveFriendGroup(currentUserId, groupId)
      setGroupActionMsg("Vous avez quitté le groupe")
      setFriendAction(!friendAction)
      setGroupMembers((prev) => {
        const next = { ...prev }
        delete next[groupId]
        return next
      })
    } catch (err) {
      console.error("Erreur lors de la sortie du groupe", err)
      setGroupActionMsg("Erreur lors de la sortie du groupe")
    }
  }

  // Composant pour afficher la section des amis
  const FriendsSection = () => (
    <div className="friends-section">
      <div className="allFriends"> 
        {friends.length > 0 && <h2>Amis confirmés</h2>}
        {
          friends.map((f, index) => 
            <div className="friend friend-confirmed" key={index}>
              <a href={`/friends/${f.id}`} className="flex"  >
                <img src={f.profile_picture || process.env.PUBLIC_URL + "/profile_pic_default_2.svg" || "https://i.imgur.com/A7lNstm.jpg"} alt="profile"/>
                <div className="infodivfriend">
                  <p className="notranslate"> {f.firstname} {f.lastname} </p>
                  <span className="infofriendspan notranslate">{helpers.truncateString(f.email, 20)}</span>
                </div>
              </a>
              <img className="imgCancel" onClick={() => { rejectFriend(f.id) }} src={cancel} alt="Supprimer" title="Supprimer" />
            </div>
          )
        }
      </div>
      <div className="allFriends">
        {!searchTerm.trim() && invitations.length > 0 && <h2>Invitations envoyées</h2>}
        {
          !searchTerm.trim() && invitations.map((f, index) => 
            <div className="friend friend-sent" key={index}>
              <img src={f.profile_picture || process.env.PUBLIC_URL + "/profile_pic_default_2.svg" || "https://i.imgur.com/A7lNstm.jpg"} alt="profile" />
              <div className="infodivfriend">
                <p className="notranslate"> {f.firstname} {f.lastname} </p>
                <span className="infofriendspan notranslate">{helpers.truncateString(f.email, 20)}</span>
              </div>
              <img className="imgCancel" onClick={() => { cancelInvitation(f.id) }} src={cancel} alt="Annuler" title="Annuler la demande" />
            </div>
          )
        }
      </div>
      <div className="allFriends">
        {friendRequests.length > 0 && <h2>Invitations reçues</h2>}
        {
          friendRequests.map((f, index) => 
            <div className="friend friend-request" key={index}>
              <img src={f.profile_picture || process.env.PUBLIC_URL + "/profile_pic_default_2.svg" || "https://i.imgur.com/A7lNstm.jpg"} alt="profile" />
              <div className="infodivfriend">
                <p className="notranslate"> {f.firstname} {f.lastname} </p>
                <span className="infofriendspan notranslate">{helpers.truncateString(f.email, 20)}</span>
              </div> 
              <img className="friend_heart" onClick={() => { acceptFriend(f.id) }} src={heart} alt="Accepter" title="Accepter" />
            </div>
          )
        }
      </div>

    </div>
  );

  // Composant pour afficher la section des suggestions
  const SuggestionsSection = () => (
    <div className="suggestions-section">
      <h2 className="h2seg">Suggestions:</h2>
      <div className="suggestions-grid">
        {publicUsers.map((f, index) => (
          <div key={index} className="suggestion-card">
            <img 
              src={f.profile_picture || process.env.PUBLIC_URL + "/profile_pic_default_2.svg"} 
              alt="profile" 
              className="suggestion-img"
            />
            <div className="suggestion-info">
              <p className="suggestion-name notranslate">
                {helpers.truncateString(f.firstname, 10)} {helpers.truncateString(f.lastname, 10)}
              </p>
              <span className="suggestion-email notranslate">
                {helpers.truncateString(f.email, 20)}
              </span>
            </div>
            <button 
              onClick={() => addFriend(f.id)}
              className="suivre-btn"
            >
              Suivre
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  const AddFriendSection = () => 
     (
      <div className="add-friend-section">
      </div>
    );

  const groupFriendSection = (
    <div className="group-friend-section">
      <div className="friend-groups-section">
        <h2>Mes Groupe d'amis</h2>
        <div className="friend-group-create">
          <input
            type="text"
            className="friend-group-input"
            placeholder="Nom du groupe"
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
          />
          <button className="friend-group-btn" onClick={handleCreateGroup}>Créer un groupe d'amis</button>
          {groupActionMsg && <span className="group-action-msg">{groupActionMsg}</span>}
        </div>
        {myGroups.length === 0 && <p className="group-empty">Aucun groupe créé.</p>}
        {myGroups.map((group) => (
          <div className="friend-group-card" key={group.id}>
            <div className="friend-group-header">
              <div className="friend-group-title">
                {group.name || `Groupe #${group.id}`}
                {(group.leader_firstname || group.leader_lastname) && (
                  <span className="friend-group-leader">
                    {" "}({group.leader_firstname || ""} {group.leader_lastname || ""})
                  </span>
                )}
              </div>
              <div className="friend-group-actions">
                <button className="friend-group-link" onClick={() => refreshGroupMembers(group.id)}>Voir les amis</button>
                <button className="friend-group-link danger" onClick={() => handleDeleteGroup(group.id)}>Supprimer</button>
              </div>
            </div>

            <div className="friend-group-add">
              <select
                value={selectedFriendByGroup[group.id] || ""}
                onChange={(e) => setSelectedFriendByGroup({ ...selectedFriendByGroup, [group.id]: e.target.value })}
              >
                <option value="">Ajouter un ami...</option>
                {friends.map((f) => (
                  <option key={f.id} value={f.id}>
                    {f.firstname} {f.lastname}
                  </option>
                ))}
              </select>
              <button
                className="friend-group-btn"
                disabled={!selectedFriendByGroup[group.id]}
                onClick={() => handleAddFriendToGroup(group.id)}
              >
                Ajouter
              </button>
            </div>

            {groupMembers[group.id] && (
              <div className="friend-group-members">
                {groupMembers[group.id].length === 0 && <p className="group-empty">Aucun ami dans ce groupe.</p>}
                {groupMembers[group.id].map((m) => (
                  <div className="friend-group-member" key={m.id}>
                    <span className="notranslate">{m.firstname} {m.lastname}</span>
                    <img
                      className="imgCancel"
                      onClick={() => handleRemoveFriendFromGroup(group.id, m.id)}
                      src={cancel}
                      alt="Retirer"
                      title="Retirer du groupe"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="friend-groups-section">
        <h2>Autres groupes d'ami</h2>
        {otherGroups.length === 0 && <p className="group-empty">Aucun autre groupe.</p>}
        {otherGroups.map((group) => (
          <div className="friend-group-card" key={group.id}>
            <div className="friend-group-header">
              <div className="friend-group-title">
                {group.name || `Groupe #${group.id}`}
                {(group.leader_firstname || group.leader_lastname) && (
                  <span className="friend-group-leader">
                    {" "}({group.leader_firstname || ""} {group.leader_lastname || ""})
                  </span>
                )}
              </div>
              <div className="friend-group-actions">
                <button className="friend-group-link" onClick={() => refreshGroupMembers(group.id)}>Voir les amis</button>
                <button className="friend-group-link danger" onClick={() => handleLeaveGroup(group.id)}>Quitter</button>
              </div>
            </div>
            {groupMembers[group.id] && (
              <div className="friend-group-members">
                {groupMembers[group.id].length === 0 && <p className="group-empty">Aucun ami dans ce groupe.</p>}
                {groupMembers[group.id].map((m) => (
                  <div className="friend-group-member" key={m.id}>
                    <span className="notranslate">{m.firstname} {m.lastname}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="friendcontainer mt-8">
      <div className="titlefriend">
        <img src={amis} alt="amis"/>
        <h1>Tous les amis</h1>
      </div>
      
      <div className="view-tabs">
        <button 
          className={`view-tab ${activeView === "friends" ? "view-tab-active" : ""}`}
          onClick={() => setActiveView("friends")}
        >
          Mes Amis
          {(friends.length > 0 || friendRequests.length > 0 || invitations.length > 0) && 
            <span className="count-badge">{friends.length + friendRequests.length + invitations.length}</span>
          }
        </button>
        <button 
          className={`view-tab ${activeView === "suggestions" ? "view-tab-active" : ""}`}
          onClick={() => setActiveView("suggestions")}
        >
          Suggestions
          {publicUsers.length > 0 && <span className="count-badge">{publicUsers.length}</span>}
        </button>
        <button 
          className={`view-tab ${activeView === "addFriend" ? "view-tab-active" : ""}`}
          onClick={() => setActiveView("addFriend")}
        >
          Ajouter un ami
        </button>
        <button 
          className={`view-tab ${activeView === "groupFriend" ? "view-tab-active" : ""}`}
          onClick={() => setActiveView("groupFriend")}
        >
          Groupe d'ami
          {(myGroups.length > 0 || otherGroups.length > 0) && 
            <span className="count-badge">{myGroups.length + otherGroups.length}</span>
          }
        </button>
      </div>
      
      <div className="content-container">
        <div className="search-container">
          
            {
              (activeView === "friends"  || activeView === "suggestions") && (
              <><Paper
            component="form"
            onSubmit={handleSubmit}
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              maxWidth: "386px",
              marginTop: 0,
              borderRadius: "67px",
              border: "1px solid #008eb5"
            }}
          ><InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Recherche amis ..."
              inputProps={{ "aria-label": "Rechercher" }}
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
            />
            <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon />
            </IconButton></Paper></>
            )}
            {
              activeView === "addFriend" && (<>
                <div className="add-friend-section">
                  <h2>Envoyer une invitation par e-mail</h2>
                  {resultAddFriend && <p className="result-message">{resultAddFriend}</p>}
                </div>
              <Paper
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                addFriendByEmail(userEmail);
              }}
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                maxWidth: "386px",
                marginTop: 0,
                borderRadius: "67px",
                border: "1px solid #008eb5"
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Ajouter un ami par e-mail ..."
                inputProps={{ "aria-label": "Ajouter un ami par e-mail" }}
                value={userEmail}
                onChange={(event) => setUserEmail(event.target.value)}
              />
            </Paper></>
          )}
        </div>

        <div className="view-content max-h-[65vh] overflow-y-auto">
          {activeView === "friends" && <FriendsSection />}
          {activeView === "suggestions" && <SuggestionsSection />}
          {activeView === "addFriend" && <AddFriendSection />}
          {activeView === "groupFriend" && groupFriendSection}
        </div>
      </div>
    </div>
  );
  
};

export default Friend;
